import {
  Card,
  CardContent,
} from "./ui/card";
import { Button } from "./ui/button";
import {
  Copy,
  Share2,
  RefreshCw,
  Clock,
} from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectShopDetails } from "../utility/Redux/profile";
import { QRCodeSVG } from "qrcode.react";

const EXPIRY_TIME = 5 * 60 * 1000; // 5 minutes

export default function ShopVisitCode() {
  const shopDetails = useSelector(selectShopDetails);
  const [expiresAt, setExpiresAt] = useState(Date.now() + EXPIRY_TIME);
  const [timeLeft, setTimeLeft] = useState(EXPIRY_TIME);
  const [copied, setCopied] = useState(false);

  const qrPayload = useMemo(() => {
    return JSON.stringify({
      shop: shopDetails?.account_no,
      expiresAt,
    });
  }, [shopDetails, expiresAt]);
console.log(qrPayload)
  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      const diff = expiresAt - Date.now();
      setTimeLeft(diff > 0 ? diff : 0);

      if (diff <= 0) {
        handleRefresh();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [expiresAt]);

  const formatTime = (ms) => {
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(qrPayload);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRefresh = () => {
    setExpiresAt(Date.now() + EXPIRY_TIME);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "Shop Visit QR",
        text: "Scan this QR to visit the shop",
      });
    }
  };

  return (
    <div className="space-y-6">
      <Card className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white border-0">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center space-y-6">
            
            {/* REAL QR CODE */}
            <div className="bg-white p-4 rounded-2xl shadow-xl">
              <QRCodeSVG
                value={qrPayload}
                size={220}
                level="H"
              />
              <p className="text-gray-600 text-center mt-2">
                Scan to Visit Shop
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-wrap gap-3 justify-center w-full">
              {/* <Button onClick={handleCopy} variant="secondary">
                {copied ? "Copied!" : "Copy QR Data"}
              </Button>

              <Button onClick={handleShare} variant="secondary">
                <Share2 className="w-4 h-4 mr-1" />
                Share
              </Button> */}

              <Button onClick={handleRefresh} variant="secondary">
                <RefreshCw className="w-4 h-4 mr-1" />
                Refresh
              </Button>
            </div>

            {/* Expiry */}
            <div className="flex items-center gap-2 text-white/80">
              <Clock className="w-4 h-4" />
              <span>Expires in: {formatTime(timeLeft)}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
